import { Badge } from '@radix-ui/themes';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IVideoResolution } from 'lib_ts/interfaces/i-video';
import { isNil } from 'lodash';
import { useMemo } from 'react';

export const VideoResolutionBadge = (props: { value: IVideoResolution }) => {
  const color = useMemo(() => {
    if (isNil(props.value.cap_size_0) || isNil(props.value.cap_size_1)) {
      return undefined;
    }

    if (props.value.cap_size_0 >= 1080) {
      return RADIX.COLOR.SUCCESS;
    }

    if (props.value.cap_size_0 >= 720) {
      return RADIX.COLOR.WARNING;
    }

    return RADIX.COLOR.DANGER;
  }, [props.value]);

  if (isNil(props.value.cap_size_0) || isNil(props.value.cap_size_1)) {
    return null;
  }

  return (
    <Badge color={color}>
      {props.value.cap_size_1} x {props.value.cap_size_0}
    </Badge>
  );
};
